import script from "./InfoCenterMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoCenterMobile.vue?vue&type=script&setup=true&lang=js"

import "./InfoCenterMobile.vue?vue&type=style&index=0&id=44006982&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44006982"]])

export default __exports__